<template>
  <div id="balance-usage">
    <div class="pop-content">
      <div class="close" @click="close"></div>
      <div class="wrap">
        <div class="items">
          <div class="title">上上签账户（或称“账户”）</div>
          <div class="anser">指用户根据《上上签用户协议》约定成功注册并经上上签验证后，上上签为您开立的账户。</div>
        </div>
        <div class="items">
          <div class="title">什么是账户余额（或称“余额”）？</div>
          <div class="anser">余额是当前用户的账户余额，可用于购买上上签商品或服务。账户余额不可提现，不可找零，不得转让、赠与。</div>
        </div>
        <div class="items">
          <div class="title">如何获得余额？</div>
          <div class="anser">余额可通过充值、赠送等形式获取。</div>
          <div class="anser">充值：您可以将您银行卡或支付宝账户或微信账户内资金划转到您的上上签账户内。</div>
          <div class="anser">赠送：您可以根据上上签平台规则获得赠送余额。</div>
        </div>
        <div class="items">
          <div class="title">余额的使用方式及退款</div>
          <div class="anser">您选购商品或服务之后，在“确认订单”时，选择“余额支付”，如果届时账户余额大于或等于该订单的金额的，即可用余额对该订单进行全额支付；如果用账户余额小于该订单金额的，需要通过充值补齐或选择其他支付方式支付。如果您使用余额支付后，交易取消或退款的，使用的余额将返还至您的账户。</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'balance-usage',
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="less" scoped>
@import  '../../../../assets/less/variable';
#balance-usage {
  position:fixed;
  top:0;
  left:0;
  right: 0;
  bottom:0;
  z-index:100;
  background-color: rgba(0,0,0,0.2);
  .pop-content{
    position:absolute;
    top: 110px;
    left:50%;
    transform:translateX(-50%);
    -ms-transform:translateX(-50%);
    width: 700px;
    height:540px;
    background-color: #fff;
    padding: 55px 0 0 0;
    .wrap{
      padding: 0 55px;
      .items{
        &+.items{
          margin-top: 30px;
        }
        .title{
          font-size: 16px;
          color:@main;
          margin-bottom: 10px;
          font-weight: 600;
        }
        .anser{
          font-size: 14px;
          color: #333;
          line-height:25px;
        }
      }
    }
  }
  .close{
    position:absolute;
    right: 20px;
    top:20px;
    width:14px;
    height:14px;
    background-size: 100%;
    background-image: url(../../../../assets/imgs/close@3x.png);
    cursor:pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/user-children/components/balance-usage.vue